module.exports = __webpack_public_path__ + "static/media/polymedia-citrus.db992e68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/polymedia-citrus.png
// module id = 16
// module chunks = 1